<button class="user-btn" (click)="dropdownMenu.toggle($event)">
  <span class="user-initials">{{ currentUser?.initials }}</span>
  <span class="user-name">{{ currentUser?.name || '' }}</span>
</button>

<rkt-menu className="user-dropdown" #dropdownMenu [model]="dropdownMenuItems"></rkt-menu>
